<!--
 * @Author: 首页
 * @Date: 2020-07-23 09:52:48
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 15:23:08
 * @FilePath: \car-demo\src\views\Home.vue
-->
<template>
  <div class="home">
    <!--
      页面浮层
    -->
    <a v-if="index_data.complaint_on_off > 0 && index_data.complaint_type == 1 && index_data.complaint_link"
       @click="jumpCustomForm" href="javascript:;" class="complain">{{ index_data.complaint_title }}</a>
    <a v-if="index_data.complaint_on_off > 0" href="javascript:;" class="rule" @click="$router.push({ path: 'rules' })">
      <template v-if="this.$ajax.is_activity()">活动规则</template>
      <template v-else>活动规则</template>
    </a>


    <!-- 我要分享 START -->
    <a v-show="index_data.share_switch == '1'"
       href="javascript:;"
       class="go2share"
       @click="$router.push({ path: '/ActivityShare',query:{activity_id:activity_id} })"
    >
      <img src="../assets/images/share_icon.png" alt="我要分享"/>
    </a>
    <!-- 我要分享 END -->


    <!-- 去领红包 -->
    <a v-if="index_data.hongbao_switch == '1' && hongbao_info.can_show" href="javascript:" class="go2packet">
      <div v-if="hongbao_info.can_get">
        <label class="text" @click="showPacket()">{{ cat_get_text }}</label>
      </div>
      <!--      <div v-else-if="!hongbao_info.can_get">-->
      <!--        <label class="text"  >{{ cat_get_text }}</label>-->
      <!--      </div>-->
      <div v-else>
        <label class="text" style="font-size: 12px;">
          {{ cat_get_text }}
        </label>
      </div>
      <img src="../assets/images/packet_icon.png" alt="领红包"/>
    </a>
    <!-- 去领红包 -->

    <!-- 帮我选驾校 -->
    <a v-show="index_data.store_switch == '1'" href="javascript:;" class="go2find" style="top: 70%;"
       @click="$router.push({ path: '/FindDriving' })">
      <img src="../assets/images/go2find.png" alt="选驾校"/>
    </a>


    <div class="symkjj" v-if="index_data && index_data.key_sort_on_off && index_data.key_sort_on_off.length"
         v-for="(idata,ik) in index_data.key_sort_on_off" :key="ik">


      <Swiper :paginationVisible="true" v-if="idata.key === 'active_head_pic' && idata.on_off"/>
      <!-- 活动通告 -->
      <div v-if="idata.key === 'notice' && idata.on_off != 0"
           style="width: 58px;height: 15px;margin-left: 35px;margin-top: 7px;position: absolute;z-index:6;">
        <img src="../assets/images/hdgg.png"
             style="width: 50px;height: 15px;margin-top: 6px;margin-left: -9px;"><span>：</span>
      </div>
      <nut-noticebar v-if="idata.key === 'notice' && idata.on_off != 0"
                     class="custom-notice"
      >
        <!--<a :href="index_data.notice_link" target="_blank" class="text">{{ index_data.notice_content }}</a>-->
        <a v-if="index_data.notice_on_off" @click="jumpNotice(index_data)" target="_blank"
           class="text">{{ index_data.notice_content }}</a>
      </nut-noticebar>

      <!-- 统计栏 -->
      <Panel :data="index_data" v-if="idata.key === 'fake_user_status' && idata.on_off != '0'"/>

      <!-- 导航 -->
      <Navigate :list="index_data.nav" v-if="idata.key === 'nav' && idata.on_off != 0"/>

      <!-- 营销专区 -->
      <Modules v-if="idata.key === 'marketing_area' && idata.on_off != 0" :navList="idata.nav_list" />

      <!--   直播   -->
      <b style="display: block;margin-bottom: 10px;margin-top: 32px;" class="title" v-if="idata.key === 'live' && idata.on_off != 0">{{ index_data.live_title }}</b>
      <Live :index_data="index_data" v-if="idata.key === 'live' && idata.on_off != 0" />

      <Advertise style="margin-top: 32px;" v-if="idata.key === 'ad1' && idata.on_off != 0 && adLists && adLists[21] && adLists[21].ad_id"
                 height="74px"
                 href="javascript:"
                 :item="adLists[21]"
      />

      <!--   参与驾校   -->
      <List style="margin-top: 32px;" :title="index_data.drive_school_title" @more="$router.push({ name: 'StList' })"
            v-if="idata.key === 'drive_school' && idata.on_off !=0 && schoolList">
        <div v-if="schoolList.length > 0">
          <div class="card list-item" @click="routerToDetail(item.store_id)" v-for="item in schoolList"
               :key="item.store_id">
            <SchoolItem :width="'120px'" :height="'90px'" :store-detail=item></SchoolItem>
          </div>
        </div>
        <div class="data-empty" v-else>
					<img src="../assets/images/empty-1.png">
					<span>暂无内容~</span>
        </div>
      </List>

      <Advertise style="margin-top: 32px;" v-if="idata.key === 'ad2' && idata.on_off != 0 && adLists && adLists[22] && adLists[22].ad_id"
                 href="javascript:"
                 :item="adLists[22]"
      />

      <!--   拼团学车   -->
      <List style="margin-top: 32px;" :title="index_data.team_car_title" @more="$router.push({ name: 'Pintuan' })"
            v-if="idata.key === 'team_car' && idata.on_off != 0">
        <div v-if="groupClassList.length > 0">
          <div class="card list-item" v-for="item in groupClassList" :key="item.id"
               @click="$router.push({ name: 'ClassTypeDetail', query: { team_detail_id: item.id } })">
            <PintuanItem :borderBottom="true" :data="item"/>
          </div>
        </div>
        <div class="data-empty" v-else>
					<img src="../assets/images/empty-1.png">
					<span>暂无内容~</span>
        </div>
      </List>

      <List style="margin-top: 32px;" v-if="idata.key === 'coupon' && idata.on_off != 0 && index_data"
            :title="index_data.coupon_title" @more="$router.push({ name: 'CouponSection' })">
        <div class="platform-lists" v-if="couponsData.length > 0">
          <div class="platform-list" v-for="item in couponsData" :key="item.id">
            <Coupons :width="'100%'" :height="'100px'" :isClick="true" :coupons-data="item"
                     :coupons-tab="parseInt(item.type)"
                     @getCoupon="getCoupon"></Coupons>
          </div>
        </div>
        <div class="data-empty" v-else>
					<img src="../assets/images/empty-1.png">
					<span>暂无内容~</span>
        </div>
      </List>

      <List style="margin-top: 32px;" v-if="idata.key === 'coach_red' && idata.on_off != 0 && jlhrb && jlhrb.lists"
            :title="jlhrb.title" @more="$router.push({name: 'Ranking' })">
        <div v-if="jlhrb && jlhrb.lists && jlhrb.lists.length">
          <div class="card list-item" v-for="(item, index) in jlhrb.lists" :key="item.id"
               @click="$router.push({ name: 'CoachDetail', query: { coach_id: item.id } })">
            <InstructorItem :index="index" :item="item"></InstructorItem>
          </div>
        </div>
        <div class="data-empty" v-else>
					<img src="../assets/images/empty-1.png">
					<span>暂无内容~</span>
        </div>
      </List>

      <Advertise style="margin-top: 32px;" v-if="idata.key === 'ad3' && idata.on_off != 0 && adLists && adLists[23] && adLists[23].ad_id"
                 height="74px"
                 href="javascript:"
                 :item="adLists[23]"
      />


    </div>


    <!-- 弹窗全部放到页面最底部 👇👇👇👇 -->
    <!-- 红包 -->
    <Packet v-model="isVisible" @change="get_hongbao_info" :hongboaid="hongbao_info.id"/>

    <div id="capture" class="my-popup">
      <img class="close" src="@/assets/images/close.png" alt="关闭" @click="closePinTuan" />
      <div class="popup-wrap">
        <p class="name">参与“{{ fllow_data.nickname }}”的拼单</p>
        <p class="desc" style="margin-bottom: 20px;">仅剩{{ fllow_data.less }}个名额，
          <nut-countdown
              :end-time="timeData"
              :show-days="true"
              @on-end="teamFinish"
          >
          </nut-countdown>
          后结束
        </p>
        <div class="heads" v-if="fllow_data.need == 2" style="margin-left: 70px;">
          <img v-for="(item, index) in fllow_data.teamHead" :src="item" alt="">
        </div>
        <div class="heads" v-else-if="fllow_data.need == 1" style="margin-left: 87px;">
          <img v-for="(item, index) in fllow_data.teamHead" :src="item" alt="">
        </div>
        <div class="heads" v-else-if="fllow_data.need == 3" style="margin-left: 46px;">
          <img v-for="(item, index) in fllow_data.teamHead" :src="item" alt="">
        </div>
        <div class="heads" v-else style="margin-left: 28px;">
          <img v-for="(item, index) in fllow_data.teamHead" :src="item" alt="">
        </div>

<!--        <nut-button shape="circle" class="button" style="margin-top:20px;background-color:#3c43ec!important;"-->
<!--                    v-if="fllow_data.pt_is_success == 1"-->
<!--                    @click="$router.push({ path: 'ClassTypeDetail', query: { team_detail_id: fllow_data.team_detail_id, found_id:fllow_data.found_id} })"-->
<!--                    :disabled="false"> -->
          <nut-button shape="circle" class="button" style="margin-top:20px;background-color:#3c43ec!important;"
                    v-if="fllow_data.pt_is_success == 1"
                    @click="canyuPinTuan()"
                    :disabled="false">
          参与拼单
        </nut-button>
        <nut-button shape="circle" class="button" style="margin-top:20px;background-color:#3c43ec!important;"
                    v-if="fllow_data.pt_is_success == 2"
                    :disabled="isButtonDisabled">
          拼团活动已结束
        </nut-button>
      </div>
    </div>

    <!-- <nut-popup
        :style="{ width: '280px', height: '240px' }"
        v-model="show"
        closeable
        class="my-popup"
    >
      <div class="popup-wrap">
        <img :src="shareImg" class="share-img">
      </div>
    </nut-popup> -->


    <!-- 选择优惠券弹窗 -->
    <nut-popup position="bottom" closeable close-icon="cross" v-model="couponsPopupShow"
               :overlay="true" class="coupons-popup-content">
      <div class="popup-title">选择优惠券</div>
      <div class="coupons" v-if="couponPopupData">
        <Coupons :width="'100%'" :height="'100px'" :coupons-data="couponPopupData"
                 :coupons-tab="parseInt(couponPopupData.type)"></Coupons>
      </div>
      <div class="rules" v-if="couponPopupData">
        <div class="rules-title">
          <div class="left-line"></div>
          <span>使用规则</span>
          <div class="right-line"></div>
        </div>
        <div class="rules-content" v-html="couponPopupData.rule">

        </div>
      </div>
      <div class="opration" v-if="couponPopupData">
        <div class="plat-o" v-if="couponPopupData && couponPopupData.price<=0">
          <div class="btn" @click="formPopupShow=true">立即领取</div>
          <div class="prompt">领取优惠券后，驾校/教练将会与你电话联系</div>
        </div>
        <div class="st-o" v-else>
          <div class="money">实付：￥{{ couponPopupData.price }}元</div>
          <div class="btn" @click="buyCoupon">立即购买</div>
        </div>
      </div>
    </nut-popup>
    <!-- 免费领取信息流弹窗 -->
    <nut-popup position="bottom" v-model="formPopupShow" :style="{ height: '497px' }" :overlay="true"
               class="info-popup-content">
      <div class="popup-title">
        <img src="../assets/images/icon_left.png" alt="" @click="closeInfoPopup">留下你的信息，驾校将会与你联系
      </div>
      <div class="myform">
        <FreeForm ref="freeform" :freeformsubmitsuccess="freeformsubmitsuccess" :couponid="couponPopupData.id"
                  source="coupon"/>
      </div>
      <div class="opration" style="bottom: 68px;">
        <div class="btn" @click="helpFindDriving">提交</div>
        <div class="prompt">领取优惠券后，驾校/教练将会与你电话联系</div>
      </div>
    </nut-popup>
    <div class="zd-layer" style="display:none"></div>
  </div>
</template>

<script>
var activity_id;
var join_page = new Date().getTime() / 1000;
import Swiper from '@/components/Swiper'
import Panel from '@/components/Panel'
import Navigate from '@/components/Navigate'
import Packet from '@/components/Packet'
import Modules from '@/components/Modules'
import Live from '@/components/Live'
import Advertise from '@/components/Advertise'
import SchoolItem from '@/components/SchoolItem' // 驾校
import PintuanItem from '@/components/PintuanItem' // 拼团
import Coupons from '@/components/Coupons' // 优惠券
import InstructorItem from '@/components/InstructorItem' // 教练
import empty from './Empty'
import FreeForm from '@/components/FreeForm'
// 引入Mixin
import danmuMixin from '@/mixins/danmu'
import cache from "../utils/cache"

export default {
  name: 'Home',
  mixins: [danmuMixin], // 插入mixin到页面，可引入多个，逗号分隔。
  components: {
    empty,
    Swiper,
    Panel,
    Navigate,
    Packet,
    Modules,
    Live,
    Advertise,
    SchoolItem,
    PintuanItem,
    Coupons,
    InstructorItem,
    FreeForm
  },
  data: () => ({
    activity_id: 0,
    isVisible: false,
    data: [],
    hongbao_info: [],
    timer: null,
    timer1: 0,
    cat_get_text: "不可领",
    timeData: 1605319689000,
    //内页的3个广告位
    adLists: {},

    fllow_data: {need: 0, join: 0, goods_name: '', end_time: '', less: 0, team_detail_id: 0, found_id: 0},


    show: false,
    jlhrb: {
      title: '教练红人榜',
      lists: []
    },
    formPopupShow: false,
    couponsPopupShow: false,
    couponPopupData: {},
    couponsData: [],//优惠券
    index_data: {
      notice_content: '我是公告',
      notice_link: '我是跳转链接'
    },
    schoolList: [],
    groupClassList: [],
    isButtonDisabled: false,
    shareImg: '',
    reward_end_time: 86400 * 1000,  //红包倒计时时间
  }),
  created() {
    if (!this.$ajax.get_activity_id()) {
      this.$router.push({name: 'Empty', query: {'error': '活动不存在'}});
    } else {
      activity_id = this.$ajax.get_activity_id();
      this.activity_id = activity_id

      //获取投诉，规则，公告
      this.getIndexData(() => {
        this.get_jlhrb(this.index_data.coach_red_number);//教练红人榜
        this.getCouponCarLists(this.index_data.coupon_number);//优惠券
      });

      this.get_hongbao_info();//获取红包信息
      this.getAdLists();//首页内3个广告
      this.getSchoolList(); //推荐驾校
      this.getGroupClassList(); //首页拼团推荐列表
      this.get_found();//判断是否平团来的
      this.add_view_count();  //新增浏览量
    }

  },
  mounted() {
    //let _this = this
    // setInterval(() => {
    //   if (this.hongbao_info.can_get) {
    //     $('#hongbao_text').css({"bottom" : "43px!important"});
    //
    //   }
    // }, 300)
  },
  methods: {
    canyuPinTuan(){
      // query: { team_detail_id: fllow_data.team_detail_id, found_id:fllow_data.found_id} }
      this.$ajax.get('m/order/add_order', {
        activity_id: this.$ajax.get_activity_id(),
        team_id: this.fllow_data.team_detail_id,
        team_price_type:1,
        order_prom_type: 1221,
        team_fllow_type:"follow",
        found_id:this.fllow_data.found_id,
        num: 1
      }).then(order_id => {
        //跳转到支付页面
        this.$router.push({name: 'SureOrder', query: {order_id: order_id}});
      })
    },
    screenShot() {
      let _this = this
      //, {
      //  useCORS: true,
      //  width: '280',
      //  height: '240',
      //  windowWidth: document.body.scrollWidth,
      //  windowHeight: document.body.scrollHeight,
      //  x:0,
      //  y:window.pageYOffset
      //}
      // html2canvas(document.querySelector('#capture')).then((canvas) => {
      //   _this.shareImg = canvas.toDataURL("image/png")
      // })
      //

    },
    //公告跳转
    jumpNotice(data) {
      if (parseInt(data.complaint_type) == 1) {
        if (data.complaint_link_detail !== null && data.complaint_link_detail !== 'null') {
          if (data.complaint_query) {
            var queryKey = data.complaint_query_field;
            this.$router.push({name: data.complaint_link_detail, query: {[queryKey]: data.complaint_query}});
          } else {
            this.$router.push({name: data.complaint_link_detail, query: {}});
          }
        }
      } else if (parseInt(data.complaint_type) == 2) {
        if (data.complaint_link_detail !== null && data.complaint_link_detail !== 'null') {
          window.location.href = data.complaint_link_detail
        }
      } else {

      }

    },
    // 关闭信息流弹窗
    closeInfoPopup() {
      this.formPopupShow = false;
    },
    routerToDetail(id) {
      this.$router.push({name: 'StDetail', query: {id: id}});
    },
    routerPinToDetail(id) {
      this.$router.push({name: 'ClassTypeDetail', query: {team_detail_id: id}});
    },
    /*
     * 获取优惠券回调
     * @param {Array} arg - 点击回调数据
     */
    getCoupon(couponPopupData) {
      this.couponPopupData = couponPopupData;
      this.couponsPopupShow = true;
    },
    freeformsubmitsuccess() {
      this.couponsPopupShow = false;
      this.formPopupShow = false;
    },
    // 提交表单
    helpFindDriving() {
      this.$refs.freeform.submit();
    },
    buyCoupon() {
      this.$ajax.get('m/order/add_order', {
        activity_id: this.$ajax.get_activity_id(),
        coupon_id: this.couponPopupData.id,
        order_prom_type: 1223,
        num: 1
      }).then(order_id => {
        this.$router.push({name: 'SureOrder', query: {order_id: order_id}});
      })
    },

    jumpCustomForm() {
      //0 无链接 1:qpp  2:webapp
      var host = window.location.host;
      if (this.index_data && this.index_data.complaint_type == 1 && this.index_data.complaint_link) {
        if(this.index_data.complaint_link_detail.indexOf("maintain") != -1){
            window.location.href = 'http://'+host+'/'+this.index_data.complaint_link_detail+'/#/';
        }else if(this.index_data.complaint_link_detail.indexOf("businessList") != -1){
            window.location.href = 'http://'+host+'/maintain/#/pages/store-list/store-list?project_id=0';
        }else{
          let query = {
            activity_id: this.$ajax.get_activity_id(),
            id: this.index_data.complaint_link
          };

          this.$router.push({name: this.index_data.complaint_link_detail, query: query})
        }
        

      }
    },
    get_jlhrb(pageSize) {
      if (this.index_data.coach_red_on_off == '1') {
        this.$ajax.get('m/gift/gift_ranking_by_sale_adviser', {
          activity_id: this.$ajax.get_activity_id(),
          page_size: pageSize,
          is_index:'1',
        }).then(res => {
          this.jlhrb = res;
        })
      }
    },
    get_hongbao_info() {
      this.hongbao_info.can_get = false
      this.cat_get_text = '不可领';

      this.$ajax.get('/m/Hongbao/ajax_hongbao_list', {
        activity_id: this.$ajax.get_activity_id(),

      }).then(res => {
        this.hongbao_info = res;
        this.reward_end_time = res.reward_end_time;

        //可领取的情况下,展示倒计时
        if (this.hongbao_info.can_get) {
          this.hongbao_info.can_get = false
          this.cat_get_text = '不可领';

          //定时器
          let timer = setInterval(() => {
            if (this.reward_end_time <= 0) {
              this.hongbao_info.can_get = true;
              this.cat_get_text = '可领取';
              clearInterval(timer);
            } else {
              let hour = parseInt(this.reward_end_time / 3600);
              let minute = parseInt(this.reward_end_time / 60 - (hour * 60));
              let second = this.reward_end_time % 60
              hour = hour < 10 ? '0' + hour : hour;
              minute = minute < 10 ? '0' + minute : minute;
              second = second < 10 ? '0' + second : second;
              this.cat_get_text = `${hour}:${minute}:${second}`;
            }
            this.reward_end_time--;

          }, 1000)
        }
      })
    },

    showPacket() {
      if (this.hongbao_info.can_get) {
        this.isVisible = true;
      }
    },
    //推荐驾校列表
    getSchoolList() {
      this.$ajax.get('/m/getlist/recommend_store_list', {
        activity_id: this.$ajax.get_activity_id(),
      }).then(res => {
        this.schoolList = res;
      });
    },
    //首页推荐拼团列表
    getGroupClassList() {
      this.$ajax.get('/m/getlist/group_class_list', {
        activity_id: this.$ajax.get_activity_id(),
      }).then(res => {
        this.groupClassList = res;
      });
    },
    getAdLists() {
      //let abBanner = window.sessionStorage.getItem('home_ad_banner');
      let abBanner = cache.get('home_ad_banner');
      if (abBanner) {
        let res = JSON.parse(abBanner);
        for (let i = 0, len = res.length; i < len; i++) {
          this.adLists[res[i].media_type] = res[i];
        }
        this.$forceUpdate();
      } else {
        this.$ajax.get('m/system/ad_banner', {
          activity_id: this.$ajax.get_activity_id(),
          pos: 20
        }).then(res => {
          if (res) {
            //window.sessionStorage.setItem('home_ad_banner', JSON.stringify(res));
            cache.set('home_ad_banner', JSON.stringify(res))
          }
          for (let i = 0, len = res.length; i < len; i++) {
            this.adLists[res[i].media_type] = res[i];
          }
          this.$forceUpdate();
        })
      }
    },
    getIndexData(call) {
      var sharecode = this.$ajax.$_GET('sharecode') ? this.$ajax.$_GET('sharecode') : '';
      //let index_data = cache.get('home_index_data');
      var index_data = false;
      if (index_data) {
        this.index_data = JSON.parse(index_data);
        call();
      } else {
        this.$ajax.get('/m/trade/index_ts_fule_notice', {
          activity_id: this.$ajax.get_activity_id(),
          sharecode: sharecode,
        }).then(res => {
          if (res) {
            cache.set('home_index_data', JSON.stringify(res));
          }
          this.index_data = res;
          window.shareConf.fx_pic = res.wx_share_img;
          window.shareConf.fx_title = res.wx_share_title;
          window.shareConf.fx_memo = res.wx_share_content;
          window.shareConf.fx_url = res.url;

          window.document.title = res.title;
          shareDiy();
          call();
        })
      }
    },
    getCouponCarLists(pageSize) {
      if (this.index_data.coupon_on_off > 0) {
        this.$ajax.get('m/system/coupon_car', {
          activity_id: this.$ajax.get_activity_id(),
          page_size: pageSize,
          page: 1,
        }).then(res => {
          this.couponsData = res ? res : [];
        })
      }
    },
    clickAd(adIndex) {
      let item = this.adLists[adIndex];
      if (!item) return;



      //无链接,点击直接返回
      if (item.link_type === 'no_link') return;

      if (item.link_type === 'web_app') {
        window.location.href = item.menu_link;
        return
      }

      //app 直接跳转到内页
      if (item.link_type === 'app') {
        var host = window.location.host;
        if(item.ad_link.indexOf("maintain") != -1){
            window.location.href = 'http://'+host+'/'+item.ad_link+'/#/';
        }else if(item.ad_link.indexOf("businessList") != -1){
            window.location.href = 'http://'+host+'/maintain/#/pages/store-list/store-list?project_id=0';
        }else{
          this.$router.push(item.ad_link, {
            activity_id: this.$ajax.get_activity_id(),
            ad_id: item.ad_id
          });
        }
        
      }
    },
    //判断是否考拼团来的
    get_found() {
      var found_id = this.$route.query.found_id;
      if (found_id) {
        this.$ajax.get('/m/team/index_team_info', {
          found_id: found_id,

        }).then(res => {
          if (res.is_me) {
            this.show = false;
          } else {
            this.show = true
          }
          this.timeData = res.end_time;
          this.fllow_data = res;
          var pmWidth = window.screen.width;
          $('.zd-layer').css({"display": "block"});
          $('#capture').css({
            "left": (pmWidth - 280) / 2 + 'px',
            "top": "30%",
            "background-color": "#fff",
            "z-index": 1000
          });
        })
      }

    },
    closePinTuan(){
      $('.zd-layer').hide();
      $('#capture').hide();
    },
    teamFinish() {
      this.isButtonDisabled = true;
    },
    //增加游览次数
    add_view_count() {
      this.$ajax.get('/m/trade/add_view_count', {
        activity_id: this.$ajax.get_activity_id(),
      }).then(res => {

      });
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  overflow: auto;
}
#capture {
  width: 280px;
  height: 230px;
  position: absolute;
  top: 0;
  left: -100%;
}

.coupon-list {
  margin-bottom: 10px;
}
.close{
  position: absolute;
  width: 18px;
  right: 15px;
  top: 15px;
}
.heads {
  display: flex;

  img {
    width: 30px;
    height: 30px;
    margin-left: 6px;
    border-radius: 50%;
    object-fit: cover;
  }
}

.data-empty {
			width: 100%;
			height: 240px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			img {
				width: 180px;
				object-fit: cover;
			}
			span {
				font-size: 14px;
				color: #999;
				margin-top: 11px;
			}
		}

.my-popup {
  background-color: #fff;
  border-radius: 6px;
  .popup-wrap {
    padding: 40px 30px 30px 30px;
    text-align: center;
    line-height: 1.5em;


    .share-img {
      width: 200px
    }

    .nut-button {
      background: linear-gradient(45deg, #3c43ec 0%, #00c2ff 100%);
    }
  }

  .name {
    font-size: 15px;
    color: #333333;
    font-weight: 400;
  }

  .desc {
    font-size: 11px;
    color: #999999;
  }

  .avatar {
    width: 40px;
    height: 40px;
    margin-right: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .avatar:last-child {
    margin-right: 0;
  }

  .button {
    min-width: 160px;
    height: 40px;
    font-weight: bold;
    background: linear-gradient(45deg,
    rgba(60, 67, 236, 1) 0%,
    rgba(0, 194, 255, 1) 100%);
  }
}

.platform-lists {
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;

  .platform-list {
    width: 100%;
    height: 100px;
    margin-top: 10px;
  }
}

.coupons-popup-content {
  padding-bottom: 68px;
  z-index: 9999;
  transform: translateZ(1000px);
  .popup-title {
    width: 100%;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    color: #333;
    margin-top: 15px;
  }

  .coupons {
    width: 100%;
    height: 100px;
    box-sizing: border-box;
    padding: 0 15px;
    margin-top: 20px;

    .coupons-item-info {
      width: 277px;
      height: 100%;
      margin-right: 15px;
    }
  }

  .rules {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-top: 20px;

    .rules-title {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .left-line {
        width: 48px;
        height: 1px;
        background: linear-gradient(270deg, rgba(51, 51, 51, 1) 0%, rgba(255, 255, 255, 0) 100%);
      }

      span {
        font-size: 15px;
        color: #333;
        margin: 0 20px;
      }

      .right-line {
        width: 48px;
        height: 1px;
        background: linear-gradient(90deg, rgba(51, 51, 51, 1) 0%, rgba(255, 255, 255, 0) 100%);
      }
    }

    .rules-content {
      ::v-deep {
        img {
          width: 100%;
        }
      }

      width: 100%;
      height: 110px;
      margin-top: 10px;
      font-size: 13px;
      color: #666;
      line-height: 20px;
      overflow-y: scroll;
    }
  }

  .opration {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
    margin-top: 20px;

    .st-o {
      .money {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #666;

        span {
          color: #EB273B;
        }
      }

      .btn {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin-top: 10px;
        background: linear-gradient(222deg, rgba(255, 169, 88, 1) 0%, rgba(255, 105, 61, 1) 100%);
        border-radius: 25px;
        font-size: 15px;
        font-weight: bold;
        color: #fff;
      }
    }

    .plat-o {
      .btn {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: linear-gradient(222deg, rgba(0, 194, 255, 1) 0%, rgba(60, 67, 236, 1) 100%);
        border-radius: 25px;
        font-size: 15px;
        font-weight: bold;
        color: #fff;
      }

      .prompt {
        margin-top: 10px;
        font-size: 12px;
        color: #999;
        width: 100%;
        text-align: center;
      }
    }
  }
}

.info-popup-content {
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;

  .popup-title {
    width: 100%;
    height: 58px;
    text-align: center;
    line-height: 58px;
    position: relative;
    border-bottom: 1px #ccc solid;

    img {
      position: absolute;
      top: 18px;
      left: 14px;
    }
  }

  .myform {
    width: 100%;
    overflow: hidden;
  }

  .opration {
    width: 100%;
    position: absolute;
    bottom: 20px;
    box-sizing: border-box;
    padding: 0 15px;

    .btn {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: linear-gradient(222deg, rgba(0, 194, 255, 1) 0%, rgba(60, 67, 236, 1) 100%);
      border-radius: 25px;
      font-size: 15px;
      font-weight: bold;
      color: #fff;
    }

    .prompt {
      margin-top: 10px;
      font-size: 12px;
      color: #999;
      width: 100%;
      text-align: center;
    }
  }
}

.title {
  font-size: 15px;
  color: #333333;
  margin-left: 14px;
}

.zd-layer {
  width: 100%;
  height: 100%;
  background-color: #333;
  position: absolute;
  z-index: 500;
  top: 0;
  bottom: 0;
  opacity: 0.8;
}

// hack
.go2packet {
  text-align: center;
  color: #ffffff;
}

/deep/ .nut-cd-timer .nut-cd-block:nth-child(1) {
  display: none;
}

/deep/ .nut-cd-timer .nut-cd-dot:nth-child(2) {
  display: none;
}
</style>
